import format from 'date-fns/format'
import toDate from 'date-fns/parseISO'
import isDate from 'date-fns/isDate'

export const parseDate = (value: string) => {
   if (!value) {
      return value
   }
   if (isDate(value)) {
      return value
   }
   return toDate(value)
}

export const parseUtc = (value: string) => {
   return toDate(value + 'Z')
}

export const shortDate = (value: Date) => {
   if (!value) {
      return ''
   }
   if (typeof value === 'string') {
      return value
   }
   if (value.getTime() === 0) {
      return ''
   }
   const dateFormat = 'd MMM yyyy'
   return format(value, dateFormat)
}

export const mediumDate = (value: Date) => {
   if (!value) {
      return ''
   }

   if (typeof value === 'string') {
      return value
   }
   const dateFormat = 'EEE d MMM yyyy'
   return format(value, dateFormat)
}

export const longDate = (value: Date) => {
   if (!value) {
      return ''
   }
   if (typeof value === 'string') {
      return value
   }
   const dateFormat = 'EEEE d MMMM yyyy'
   return format(value, dateFormat)
}

export const dateTime = (value: Date) => {
   if (typeof value === 'string') {
      return value
   }
   if (value.getTime() === 0) {
      return ''
   }
   const dateFormat = 'MMM d, yyyy h:mm a'
   return format(value, dateFormat)
}

export const monthAndYear = (value: Date) => {
   if (typeof value === 'string') {
      return value
   }
   if (value.getTime() === 0) {
      return ''
   }
   const dateFormat = 'MMMM yyyy'
   return format(value, dateFormat)
}
